import { ChevronRight, LogOut, User, LogIn, UserPlus } from "lucide-react";

import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuGroup,
	DropdownMenuItem,
	DropdownMenuSeparator,
	DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {
	SidebarMenu,
	SidebarMenuButton,
	SidebarMenuItem,
	useSidebar,
} from "@/components/ui/sidebar";
import { Link, useNavigate } from "react-router";
import { Button } from "@/components/ui/button";
import { useApp } from "@/app/providers/app-provider";

const UnAuthenticatedMenu = () => (
	<div className="flex flex-col gap-2">
		<Link to="/auth/log-in">
			<Button variant="secondary" size="lg" className="w-full">
				Log In
				<LogIn />
			</Button>
		</Link>
		<Link to="/auth/sign-up">
			<Button variant="primary" size="lg" className="w-full">
				Sign Up
				<UserPlus />
			</Button>
		</Link>
	</div>
);

const AuthenticatedMenu = ({
	email,
	logout,
}: {
	email: string;
	logout: () => void;
}) => {
	const { isMobile } = useSidebar();
	const navigate = useNavigate();

	const handleLogout = () => {
		logout();
		navigate("/");
	};

	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<SidebarMenuButton
					size="lg"
					className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
				>
					<Avatar className="h-8 w-8 rounded-lg">
						{/* <AvatarImage src={user.avatar} alt={user.name} /> */}
						<AvatarFallback className="rounded-lg">
							<User />
						</AvatarFallback>
					</Avatar>
					<div className="grid flex-1 text-left text-sm leading-tight">
						<span className="truncate text-xs">{email}</span>
					</div>
					<ChevronRight className="ml-auto size-4" />
				</SidebarMenuButton>
			</DropdownMenuTrigger>
			<DropdownMenuContent
				className="w-[--radix-dropdown-menu-trigger-width] min-w-56 rounded-lg"
				side={isMobile ? "bottom" : "right"}
				align="end"
				sideOffset={4}
			>
				<DropdownMenuGroup>
					<Link to="/account">
						<DropdownMenuItem>
							<User />
							Account
						</DropdownMenuItem>
					</Link>
				</DropdownMenuGroup>
				<DropdownMenuSeparator />
				<DropdownMenuItem onClick={handleLogout}>
					<LogOut />
					Log out
				</DropdownMenuItem>
			</DropdownMenuContent>
		</DropdownMenu>
	);
};

export function NavUser() {
	const { authManager, appStore } = useApp();

	return (
		<SidebarMenu>
			<SidebarMenuItem>
				{appStore.session ? (
					<AuthenticatedMenu
						email={appStore.session.user.email!}
						logout={authManager.signOut}
					/>
				) : (
					<UnAuthenticatedMenu />
				)}
			</SidebarMenuItem>
		</SidebarMenu>
	);
}
